import StepNavigationBase from '@components/StepNavigation'

import useAssignTemplatePagePermissions from '../../hooks/useAssignTemplatePagePermissionsModal'

interface StepNavigationProps {
  assignTemplatePagePermissionsPayload: ReturnType<typeof useAssignTemplatePagePermissions>,
  isHorizontalLayout?: boolean,
  showTickIcon?: boolean,
  newPermissionsSteps?: boolean,
}

const StepNavigation = (props: StepNavigationProps) => {
  const {
    assignTemplatePagePermissionsPayload: {
      activeStepKey,
      callbacks: { setCurrentStepKey },
      payloads: {
        agencies: { reduxActionPerformed: agenciesLoaded },
        brandThemes: { reduxActionPerformed: brandThemesLoaded },
        providers: { reduxActionPerformed: providersLoaded },
        publications: { reduxActionPerformed: publicationsLoaded },
        serviceProducts: { reduxActionPerformed: serviceProductsLoaded },
        services: { reduxActionPerformed: servicesLoaded },
        templateGroups: { reduxActionPerformed: templateGroupsLoaded },
      },
      permissions: { queued: queuedPermissions },
    },
    isHorizontalLayout,
    showTickIcon,
    newPermissionsSteps,
  } = props

  return (
    <StepNavigationBase
      activeStepKey={activeStepKey}
      callbacks={{
        setCurrentStepKey: ({ key }) => setCurrentStepKey(key),
      }}
      horizontal={isHorizontalLayout}
      showTickIcon={showTickIcon}
      steps={!newPermissionsSteps
        ? [
          {
            key: 'providerIds',
            label: 'Providers',
            body: providersLoaded ? `${queuedPermissions.providerIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'serviceProductIds',
            label: 'Products',
            body: serviceProductsLoaded ? `${queuedPermissions.serviceProductIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'agencyIds',
            label: 'Agencies',
            body: agenciesLoaded ? `${queuedPermissions.agencyIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'publicationIds',
            label: 'Publications (Optional)',
            body: publicationsLoaded ? `${queuedPermissions.publicationIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'templateGroupIds',
            label: 'Template Groups (Optional)',
            body: templateGroupsLoaded ? `${queuedPermissions.templateGroupIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'brandThemeIds',
            label: 'Brand Themes (Optional)',
            body: brandThemesLoaded ? `${queuedPermissions.brandThemeIds.length} Assigned` : 'Click to Load',
          },
        ]
        : [
          {
            key: 'serviceIds',
            label: 'Services',
            body: servicesLoaded ? `${queuedPermissions.serviceIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'providerIds',
            label: 'Providers',
            body: providersLoaded ? `${queuedPermissions.providerIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'serviceProductIds',
            label: 'Products',
            body: serviceProductsLoaded ? `${queuedPermissions.serviceProductIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'agencyIds',
            label: 'Agencies',
            body: agenciesLoaded ? `${queuedPermissions.agencyIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'publicationIds',
            label: 'Publications (Optional)',
            body: publicationsLoaded ? `${queuedPermissions.publicationIds.length} Assigned` : 'Click to Load',
          },
          {
            key: 'brandThemeIds',
            label: 'Brand Themes (Optional)',
            body: brandThemesLoaded ? `${queuedPermissions.brandThemeIds.length} Assigned` : 'Click to Load',
          },
        ]}
    />
  )
}

export default StepNavigation
